export const notification = () => {
    const allNotifications = document.querySelectorAll("[js-notification]");

    const closeNotification = (notif) => {
        notif.remove();
    };

    allNotifications.forEach((notif) => {
        const closeDelay = notif.getAttribute("js-notification-close-delay");
        const closeNotif = notif.querySelector("[js-notification-close-cta]");

        if (closeDelay) {
            const delay = Number(closeDelay) * 1000;
            setTimeout(() => {
                closeNotification(notif);
            }, delay);
        }

        if (closeNotif) {
            closeNotif.addEventListener("click", () => {
                closeNotification(notif);
            });
        }
    });
}